<template>
    <div class="courseIndex">
    <leftnav class="fl" mkcode="A" :itemcode="pagecode"></leftnav>
    <div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
        <govheader></govheader>
        <el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="25vh">
            <freeUserTips :type="4" :bgtype="0"></freeUserTips>
        </el-dialog>
        <div class="index_left_centerpage">
            <div>
                <iframe  src="http://192.168.1.82:9090/#/pagesA/video/course" width="100%" height="891" frameborder="0"></iframe>
            </div>
        </div>
    </div>
</div>
</template>
<script>
export default {
    data() {
        return {
            pagecode: 'A',
            isCollapse: false,
            isShowFreeUserTips: false
        };
    }
}
</script>
<style lang="scss" scoped>
.courseIndex{
    background: #f5f5f5;
    height: 950px;
    min-height: 950px;
    max-height: 950px;
    width: 100%;
    overflow: hidden;
}
</style>